// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"30143b4b","488":"6577a88c"}[chunkId] + ".chunk.js";
};